export default "__VITE_ASSET__CEHpdXsc__"